module.exports = __webpack_public_path__ + "media/images/onboarding-2-b42eb24552b23b39beba974838e16331.jpg";